import styled from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  width: 1002px;
  margin: 120px auto;
`;

export const Title = styled.h2`
  color: ${Palette.PrimaryGray._900};
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;
